(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herb-collections-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
    const collectionImages = document.querySelectorAll('.collection-highlight-image');
    const collectionParas = document.querySelectorAll('.collection-highlight-para');
    
    collectionImages.forEach(image => {
      const collectionUrl = image.dataset.collectionUrl;
      const currentUrl = window.location.pathname;
      console.log(collectionUrl);
      console.log(currentUrl);
      if (currentUrl === collectionUrl ) {
        image.style.border = '1px solid #faa201';
      }
    });

      collectionParas.forEach(para => {
      const collectionUrl = para.dataset.collectionUrl;
      const currentUrl = window.location.pathname;
      
      if (currentUrl === collectionUrl) {
        para.style.color = '#faa201';
      }
    });
  
 
  });

  
  class HerbSection {
    constructor() {
      // Initialize collection slider
      this.initCollectionSlider();
      // Initialize product sliders
      // this.initProductSliders();
      // Handle tab functionality
      this.handleTabs();
    }

    initCollectionSlider() {
      const collectionList = document.querySelector('.herb__collection-list');
      if (!collectionList) return;

      this.collectionFlickity = new Flickity(collectionList, {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        freeScroll: true,
        groupCells: true
      });
    }

    // initProductSliders() {
    //   const productLists = document.querySelectorAll('.herb__product-list');
    //   if (!productLists.length) return;

    //   this.productSliders = {};

    //   productLists.forEach(list => {
    //     const collectionHandle = list.dataset.content;
    //     this.productSliders[collectionHandle] = new Flickity(list, {
    //       cellAlign: 'center',
    //       contain: true,
    //       pageDots: false,
    //       prevNextButtons: false,
    //       groupCells: true
    //     });
        
    //     // Initially hide all except the first one
    //     if (list !== productLists[0]) {
    //       list.style.display = 'none';
    //     }
    //   });
    // }

    handleTabs() {
      const collectionItems = document.querySelectorAll('.herb__collection-item');
      const productLists = document.querySelectorAll('.herb__product-list');

      collectionItems.forEach(item => {
        item.addEventListener('click', () => {
          // Remove active class from all collection items
          collectionItems.forEach(i => i.classList.remove('active'));
          // Add active class to clicked item
          item.classList.add('active');

          const targetHandle = item.dataset.tab;

          // Hide all product lists
          productLists.forEach(list => {
            list.style.display = 'none';
          });

          // Show the targeted product list
          const targetList = document.querySelector(`.herb__product-list[data-content="${targetHandle}"]`);
          if (targetList) {
            targetList.style.display = 'grid';
            // Refresh the Flickity slider
            if (this.productSliders[targetHandle]) {
              this.productSliders[targetHandle].resize();
            }
          }
        });
      });

      // Set first collection item as active by default
      if (collectionItems.length) {
        collectionItems[0].classList.add('active');
      }
      // Hide all product lists except the first one initially
      if (productLists.length > 1) {
        for (let i = 1; i < productLists.length; i++) {
          productLists[i].style.display = 'none';
        }
      }
    }
  }

  // Initialize the section
  window.addEventListener('DOMContentLoaded', () => {
    new HerbSection();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herb-gift-bundles-row"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
    const collectionImages = document.querySelectorAll('.collection-highlight-image');
    const collectionParas = document.querySelectorAll('.collection-highlight-para');
    
    collectionImages.forEach(image => {
      const collectionUrl = image.dataset.collectionUrl;
      const currentUrl = window.location.pathname;
      console.log(collectionUrl);
      console.log(currentUrl);
      if (currentUrl === collectionUrl ) {
        image.style.border = '1px solid #faa201';
      }
    });

      collectionParas.forEach(para => {
      const collectionUrl = para.dataset.collectionUrl;
      const currentUrl = window.location.pathname;
      
      if (currentUrl === collectionUrl) {
        para.style.color = '#faa201';
      }
    });
  
 
  });
  
  class HerbSection {
    constructor() {
      // Initialize collection slider
      this.initCollectionSlider();
      // Initialize product sliders
      // this.initProductSliders();
      // Handle tab functionality
      this.handleTabs();
    }

    initCollectionSlider() {
      const collectionList = document.querySelector('.herb__collection-list');
      if (!collectionList) return;

      this.collectionFlickity = new Flickity(collectionList, {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        freeScroll: true,
        groupCells: true
      });
    }

    // initProductSliders() {
    //   const productLists = document.querySelectorAll('.herb__product-list');
    //   if (!productLists.length) return;

    //   this.productSliders = {};

    //   productLists.forEach(list => {
    //     const collectionHandle = list.dataset.content;
    //     this.productSliders[collectionHandle] = new Flickity(list, {
    //       cellAlign: 'center',
    //       contain: true,
    //       pageDots: false,
    //       prevNextButtons: false,
    //       groupCells: true
    //     });
        
    //     // Initially hide all except the first one
    //     if (list !== productLists[0]) {
    //       list.style.display = 'none';
    //     }
    //   });
    // }

    handleTabs() {
      const collectionItems = document.querySelectorAll('.herb__collection-item');
      const productLists = document.querySelectorAll('.herb__product-list');

      collectionItems.forEach(item => {
        item.addEventListener('click', () => {
          // Remove active class from all collection items
          collectionItems.forEach(i => i.classList.remove('active'));
          // Add active class to clicked item
          item.classList.add('active');

          const targetHandle = item.dataset.tab;

          // Hide all product lists
          productLists.forEach(list => {
            list.style.display = 'none';
          });

          // Show the targeted product list
          const targetList = document.querySelector(`.herb__product-list[data-content="${targetHandle}"]`);
          if (targetList) {
            targetList.style.display = 'grid';
            // Refresh the Flickity slider
            if (this.productSliders[targetHandle]) {
              this.productSliders[targetHandle].resize();
            }
          }
        });
      });

      // Set first collection item as active by default
      if (collectionItems.length) {
        collectionItems[0].classList.add('active');
      }
      // Hide all product lists except the first one initially
      if (productLists.length > 1) {
        for (let i = 1; i < productLists.length; i++) {
          productLists[i].style.display = 'none';
        }
      }
    }
  }

  // Initialize the section
  window.addEventListener('DOMContentLoaded', () => {
    new HerbSection();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herb-gift-bundles"] && !Shopify.designMode) return;
  try {
    
  class HerbSection {
    constructor() {
      // Initialize collection slider
      this.initCollectionSlider();
      // Initialize product sliders
      this.initProductSliders();
      // Handle tab functionality
      this.handleTabs();
    }

    initCollectionSlider() {
      const collectionList = document.querySelector('.herb__collection-list');
      if (!collectionList) return;

      this.collectionFlickity = new Flickity(collectionList, {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        freeScroll: true,
        groupCells: true
      });
    }

    initProductSliders() {
      const productLists = document.querySelectorAll('.herb__product-list');
      if (!productLists.length) return;

      this.productSliders = {};

      productLists.forEach(list => {
        const collectionHandle = list.dataset.content;
        this.productSliders[collectionHandle] = new Flickity(list, {
          cellAlign: 'center',
          contain: true,
          pageDots: false,
          prevNextButtons: false,
          groupCells: true
        });
        
        // Initially hide all except the first one
        if (list !== productLists[0]) {
          list.style.display = 'none';
        }
      });
    }

    handleTabs() {
      const collectionItems = document.querySelectorAll('.herb__collection-item');
      const productLists = document.querySelectorAll('.herb__gift-list');
      
      collectionItems.forEach(item => {
        item.addEventListener('click', () => {
          // Remove active class from all collection items
          collectionItems.forEach(i => i.classList.remove('active'));
          // Add active class to clicked item
          item.classList.add('active');

          const targetHandle = item.dataset.tab;

          // Hide all product lists
          productLists.forEach(list => {
            list.style.display = 'none !important';
          });

          // Show the targeted product list
          const targetList = document.querySelector(`.herb__gift-list[data-content="${targetHandle}"]`);
          if (targetList) {
            targetList.style.display = 'flex';
            // Refresh the Flickity slider
            if (this.productSliders[targetHandle]) {
              this.productSliders[targetHandle].resize();
            }
          }
        });
      });

      // Set first collection item as active by default
      if (collectionItems.length) {
        collectionItems[0].classList.add('active');
      }
    }
  }

  // Initialize the section
  window.addEventListener('DOMContentLoaded', () => {
    new HerbSection();
  });

  } catch(e) { console.error(e); }
})();
})();
